import React from 'react';
import AssistantCard from './AssistantCard';
import { Trash2, Users, Search } from 'react-feather';

import './AssistantList.css';

const AssistantList = ({
  assistants,
  loading,
  onUpdate,
  onDelete,
  onCreate,
  isFiltered = false,
  onClearFilter,
}) => {
  if (loading) return null;

  // The parent already filters out `inuse === false` and applies the search
  // query, so this component renders exactly what it is handed.
  const visibleAssistants = assistants || [];

  if (visibleAssistants.length === 0) {
    // Two different empty states: nothing exists yet vs. nothing matched the
    // search. Showing "create your first agent" to someone who has ten agents
    // and a typo in the search box is misleading.
    if (isFiltered) {
      return (
        <div className="assistantEmpty">
          <div className="assistantEmptyIcon" aria-hidden="true">
            <Search size={20} />
          </div>
          <h3 className="assistantEmptyTitle">No matching agents</h3>
          <p className="assistantEmptyCopy">
            No agent matches your search. Try a different name or greeting.
          </p>
          {onClearFilter && (
            <button type="button" className="assistantEmptyAction" onClick={onClearFilter}>
              Clear search
            </button>
          )}
        </div>
      );
    }

    return (
      <div className="assistantEmpty">
        <div className="assistantEmptyIcon" aria-hidden="true">
          <Users size={20} />
        </div>
        <h3 className="assistantEmptyTitle">No agents yet</h3>
        <p className="assistantEmptyCopy">
          Agents handle conversations across web and phone using your knowledge
          bases and tools. Create one to get started.
        </p>
        {onCreate && (
          <button type="button" className="assistantEmptyAction" onClick={onCreate}>
            Create Agent
          </button>
        )}
      </div>
    );
  }

  return (
    <ul className="assistantList">
      {visibleAssistants.map((assistant) => (
        <li className="assistantListRow" key={assistant.id}>
          <div className="assistantListCardWrap">
            <AssistantCard
              assistant={assistant}
              onUpdate={onUpdate}
              onDelete={onDelete}
              defaultOpen={false}
            />
          </div>

          <div className="assistantListDeleteWrap">
            <button
              type="button"
              className="assistantListDelete"
              onClick={() => onDelete(assistant.id)}
              aria-label={`Delete ${assistant.name || 'agent'}`}
              title="Delete agent"
            >
              <Trash2 size={16} aria-hidden="true" />
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default AssistantList;
